import { action } from 'satcheljs';
import { actionWithDatapoint } from 'owa-analytics-actions';

/**
 * Action to view booking dashboard
 */

export interface OpenBookingDashboardActionMessage {
    isOnPopStateOrFirstLoad: boolean | null | undefined;
    entryPoint: string | null | undefined;
}
export const openBookingDashboard: (
    isOnPopStateOrFirstLoad?: boolean | null,
    entryPoint?: string | null
) => OpenBookingDashboardActionMessage = actionWithDatapoint(
    'openBookingDashboard',
    (
        isOnPopStateOrFirstLoad?: boolean | null,
        entryPoint?: string | null
    ): OpenBookingDashboardActionMessage => ({
        isOnPopStateOrFirstLoad,
        entryPoint,
    }),
    actionMessage => ({
        customData: {
            isOnPopStateOrFirstLoad: actionMessage.isOnPopStateOrFirstLoad,
            entryPoint: actionMessage.entryPoint,
        },
    })
);

/**
 * Action to view booking compose
 */

export interface OpenBookingComposeActionMessage {
    isOnPopStateOrFirstLoad: boolean | null | undefined;
    entryPoint: string | null | undefined;
}
export const openBookingCompose: (
    isOnPopStateOrFirstLoad?: boolean | null,
    entryPoint?: string | null
) => OpenBookingComposeActionMessage = actionWithDatapoint(
    'openBookingCompose',
    (
        isOnPopStateOrFirstLoad?: boolean | null,
        entryPoint?: string | null
    ): OpenBookingComposeActionMessage => ({
        isOnPopStateOrFirstLoad,
        entryPoint,
    }),
    actionMessage => ({
        customData: {
            isOnPopStateOrFirstLoad: actionMessage.isOnPopStateOrFirstLoad,
            entryPoint: actionMessage.entryPoint,
        },
    })
);

/**
 * Action to edit a meeting
 */

export interface EditBookingMeetingActionMessage {
    meetingTypeId: string;
    isOnPopStateOrFirstLoad: boolean | null | undefined;
    entryPoint: string | null | undefined;
}
export const editBookingMeeting: (
    meetingTypeId: string,
    isOnPopStateOrFirstLoad?: boolean | null,
    entryPoint?: string | null
) => EditBookingMeetingActionMessage = actionWithDatapoint(
    'editBookingMeeting',
    (
        meetingTypeId: string,
        isOnPopStateOrFirstLoad?: boolean | null,
        entryPoint?: string | null
    ): EditBookingMeetingActionMessage => ({
        meetingTypeId,
        isOnPopStateOrFirstLoad,
        entryPoint,
    }),
    actionMessage => ({
        customData: {
            isOnPopStateOrFirstLoad: actionMessage.isOnPopStateOrFirstLoad,
            entryPoint: actionMessage.entryPoint,
        },
    })
);

/**
 * Action to view personal booking attendee page
 */

export interface OpenBookingPageActionMessage {
    bookingMailbox: string;
    entryPoint: string | null | undefined;
}
export const openBookingPage: (
    bookingMailbox: string,
    entryPoint?: string | null
) => OpenBookingPageActionMessage = actionWithDatapoint(
    'openBookingPage',
    (bookingMailbox: string, entryPoint?: string | null): OpenBookingPageActionMessage => ({
        bookingMailbox,
        entryPoint,
    }),
    actionMessage => ({
        customData: {
            entryPoint: actionMessage.entryPoint,
        },
    })
);

/**
 * Action to view personal booking attendee page
 */

export interface OpenMeetingTypePageActionMessage {
    bookingMailbox: string;
    meetingTypeId: string;
    entryPoint: string | null | undefined;
}
export const openMeetingTypePage: (
    bookingMailbox: string,
    meetingTypeId: string,
    entryPoint?: string | null
) => OpenMeetingTypePageActionMessage = actionWithDatapoint(
    'openMeetingTypePage',
    (
        bookingMailbox: string,
        meetingTypeId: string,
        entryPoint?: string | null
    ): OpenMeetingTypePageActionMessage => ({
        bookingMailbox,
        meetingTypeId,
        entryPoint,
    }),
    actionMessage => ({
        customData: {
            meetingTypeId: actionMessage.meetingTypeId,
            entryPoint: actionMessage.entryPoint,
        },
    })
);

/**
 * Action to view booked meeting details page
 */

export interface OpenMeetingDetailsPageActionMessage {
    bookingMailbox: string;
    bookingId: string;
    entryPoint: string | null | undefined;
}
export const openMeetingDetailsPage: (
    bookingMailbox: string,
    bookingId: string,
    entryPoint?: string | null
) => OpenMeetingDetailsPageActionMessage = actionWithDatapoint(
    'openMeetingDetailsPage',
    (
        bookingMailbox: string,
        bookingId: string,
        entryPoint?: string | null
    ): OpenMeetingDetailsPageActionMessage => ({
        bookingMailbox,
        bookingId,
        entryPoint,
    }),
    actionMessage => ({
        customData: {
            meetingTypeId: actionMessage.bookingId,
            entryPoint: actionMessage.entryPoint,
        },
    })
);

/**
 * Action to trigger rerender the host container.  Hacky solution until a better solution is in place.
 */
export const retriggerCurrentModule: () => {} = action('retriggerCurrentModule');
